import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'


const MachineryIndustryERP = () => {
    //const formattedLocation = location
    //    ? `in ${location.charAt(0).toUpperCase() + location.slice(1)}`
        //: "";

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: "white" }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/industrial-2-768x512.jpg" alt="Industrial Machinery" />
                    </div>
                    <div className="col-lg-6 content">
                            <h1 className="elementor-heading-title elementor-size-default">
                                Industrial Machinery & Equipment Industry Management Software {state.condText}
                        </h1>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <h2 className="elementor-heading-title elementor-size-default">
                            No matter your size, success in industrial manufacturing means...
                        </h2>
                        <p>
                            �having a complete understanding of your end-to-end production process so that you
                            can take full advantage of the cost saving benefits that are provided by new
                            automation technology. But just as important is the need to remain adaptable and
                            flexible to meet fluctuations in product demand. Changing production quickly or
                            allowing for smaller batch runs require a granular understanding of production so
                            that decisions can be made and change implemented quickly.
                        </p>
                    </div>
                    <div className="col-lg-6 content">
                        <img src="/theme/img/industrial-mach-1-1024x683.jpg" alt="Industrial Machinery" />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/bdimg8.JPG" alt="Business Management" />
                    </div>
                    <div className="col-lg-6 content">
                        <h2 className="elementor-heading-title elementor-size-default">
                            Tejaxo Xi embeds a new digital way of working into your business with easy-to-use
                            tools...
                        </h2>
                        <p>
                            <span style={{ fontWeight: 400 }}>
                                �that allow complete visibility of the complete supply chain, with continuous
                                improvement in mind. We help your business to keep agile with real-time insights
                                that can help you manage every aspect of your operations so you can stay
                                competitive when securing contracts while effectively managing those you already
                                have.
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default MachineryIndustryERP;
